import { schemas } from "@convergence/client";
import { useMutation } from "@tanstack/react-query";
import { fetch } from "../fetch";

export async function issueToken() {
    return fetch("/auth/token", { method: "POST" }, schemas.IssueTokenResponse);
}

export const useIssueTokenMutation = () => {
    return useMutation({
        mutationFn: issueToken,
        gcTime: 0,
    });
};
